import { createAction, props } from '@ngrx/store';
import { ILangCode } from '../../shared/models/language.model';

export const setLanguage = createAction(
  '[Language] Set Language',
  props<{ language: ILangCode }>()
);